// Video-Tracking (PostHog Capture-API ohne SDK) und Cart-Attribute (_video_visto, _video_ids) für die Auswertung.
// Schnittstelle: _workbench/videos/INTERFACE.md
import { fetchCart } from 'theme';

const W = window, D = document, V = W.lpVideo || {};
const tag = D.querySelector('script[data-lp-track]');
const key = tag?.dataset.key, host = (tag?.dataset.host || 'https://us.i.posthog.com').replace(/\/$/, '');
const base = {
  page_type: V.pageType,
  device: innerWidth < 700 ? 'mobile' : 'desktop',
  $current_url: location.href, $pathname: location.pathname, $referrer: D.referrer, $lib: 'lp-track',
};
let buf = [], timer, allowed = false;

const flush = () => {
  clearTimeout(timer);
  if (!allowed || !key || !buf.length) return;
  const json = JSON.stringify(buf.splice(0));
  let bin = '';
  new TextEncoder().encode(json).forEach((b) => (bin += String.fromCharCode(b)));
  // Form-Body wie posthog-js (compression=base64): kein CORS-Preflight, sendBeacon-tauglich. Als Blob ohne
  // „;charset=UTF-8“, das URLSearchParams anhängt: damit antwortet PostHog 400 „failed to parse request“.
  const url = `${host}/e/?compression=base64`;
  const body = new Blob([`data=${encodeURIComponent(btoa(bin))}`], { type: 'application/x-www-form-urlencoded' });
  try {
    if (!navigator.sendBeacon?.(url, body)) fetch(url, { method: 'POST', body, keepalive: true }).catch(() => {});
  } catch (e) {}
};

const track = (event, props, ts = Date.now()) => {
  try {
    buf.push({
      event,
      properties: { ...base, ...props, token: key, distinct_id: V.vid, $process_person_profile: false },
      timestamp: new Date(ts).toISOString(),
    });
    if (buf.length > 100) buf.shift();
    if (event === 'video_qualified_view') markSeen(props?.video_id);
    clearTimeout(timer);
    timer = setTimeout(flush, 2000);
  } catch (e) {}
};

const consent = async () => {
  try {
    let p = W.Shopify?.customerPrivacy;
    if (!p && W.Shopify?.loadFeatures) {
      p = await new Promise((r) => W.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (e) => r(e ? null : W.Shopify.customerPrivacy)));
    }
    if (p?.userCanBeTracked?.()) { allowed = true; flush(); }
  } catch (e) {}
};
consent();
D.addEventListener('visitorConsentCollected', (e) => { if (e.detail?.analyticsAllowed) consent(); });
addEventListener('pagehide', flush);
D.addEventListener('visibilitychange', () => D.visibilityState === 'hidden' && flush());

// Cart-Attribute: nur fehlende/abweichende Werte senden, Requests nacheinander
let known = {}, chain = Promise.resolve(), cartCount = 0, visto = null, ids = null;
const want = () => {
  const a = {};
  if (visto) {
    a._video_visto = known._video_visto || visto;
    a._video_ids = ids.join(',');
  }
  return a;
};
const sync = () => (chain = chain.then(async () => {
  const diff = Object.fromEntries(Object.entries(want()).filter(([k, v]) => known[k] !== v));
  if (!Object.keys(diff).length) return;
  const prev = { ...known };
  Object.assign(known, diff);
  try {
    const r = await fetch(`${W.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: diff }),
    });
    if (!r.ok) throw 0;
  } catch (e) { known = prev; }
}));
const seeCart = (cart) => {
  if (!cart) return;
  cartCount = cart.item_count || 0;
  Object.assign(known, cart.attributes || {});
  sync();
};
function markSeen(id) {
  if (!id) return;
  id = String(id);
  ids = (ids || String(known._video_ids || '').split(',').filter(Boolean)).filter((x) => x !== id).concat(id).slice(-5);
  visto = visto || new Date().toISOString();
  sync();
}
Promise.resolve(fetchCart).then(seeCart, () => {});

(W.lpTrackQ || []).splice(0).forEach(([n, p, t]) => track(n, p, t));
W.lpTrack = (n, p) => track(n, p || {});

// PDP mit Video: pdp_view / pdp_add_to_cart
const pdp = D.querySelector('[data-lp-pdp-video]')?.dataset.productId;
let added = null;
if (pdp) track('pdp_view', { product_id: pdp });
D.addEventListener('variant:add', (e) => { added = e.detail?.items; });
D.addEventListener('cart:change', (e) => {
  const d = e.detail || {};
  seeCart(d.cart);
  if (!pdp || d.baseEvent !== 'variant:add') return;
  (added || []).filter((it) => String(it.product_id) === pdp).forEach((it) =>
    track('pdp_add_to_cart', { product_id: pdp, variant_id: it.variant_id, quantity: it.quantity, price: it.final_price / 100 }));
  added = null;
});
